module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('b-radio', {
    attrs: {
      "native-value": "on-border"
    },
    model: {
      value: (_vm.labelPosition),
      callback: function($$v) {
        _vm.labelPosition = $$v
      },
      expression: "labelPosition"
    }
  }, [_vm._v("\n                On Border\n            ")]), _vm._v(" "), _c('b-radio', {
    attrs: {
      "native-value": "inside"
    },
    model: {
      value: (_vm.labelPosition),
      callback: function($$v) {
        _vm.labelPosition = $$v
      },
      expression: "labelPosition"
    }
  }, [_vm._v("\n                Inside\n            ")])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Name",
      "label-position": _vm.labelPosition
    }
  }, [_c('b-input', {
    attrs: {
      "value": "Kevin Garvey"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email",
      "label-position": _vm.labelPosition,
      "type": "is-danger",
      "message": "This email is invalid"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "value": "john@",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Username",
      "label-position": _vm.labelPosition,
      "type": "is-success",
      "message": "This username is available"
    }
  }, [_c('b-input', {
    attrs: {
      "value": "johnsilver",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password",
      "label-position": _vm.labelPosition,
      "type": "is-warning",
      "message": ['Password is too short', 'Password must have at least 8 characters']
    }
  }, [_c('b-input', {
    attrs: {
      "value": "123",
      "type": "password",
      "maxlength": "30"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Subject",
      "label-position": _vm.labelPosition
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select a subject"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Option 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Option 2")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Message",
      "label-position": _vm.labelPosition
    }
  }, [_c('b-input', {
    attrs: {
      "maxlength": "200",
      "type": "textarea"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "title is-6"
  }, [_vm._v("Also works for grouped field and with addons.")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Search...",
      "label-position": _vm.labelPosition,
      "grouped": ""
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('b-button', {
    staticClass: "button is-primary"
  }, [_vm._v("Search")])], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Search...",
      "label-position": _vm.labelPosition
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('b-button', {
    staticClass: "button is-primary"
  }, [_vm._v("Search")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee0b17aa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExLabelPosition.vue
// module id = 1087
// module chunks = 5 130